import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';
import {Crew} from '../../../../Models/Crew';
import {Link} from 'react-router-dom';

interface OwnProps {
    crews: Crew[];
    className?: string;
}

export const YourCrews: FunctionComponent<OwnProps> = ({crews, className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Your crews</h5>
            </div>
            <div className="card-body">
                {crews.length === 0 && (
                    <p>You are not a member of any crew. Organise your crew and start tracking performance together.</p>
                )}
                <table className="table">
                    <tbody>
                        {crews.map((crew, key) => {
                            return (
                                <tr key={crew.id}>
                                    <td className="d-flex flex-row gap-2">
                                        <Link to={`/crews/${crew.id}`}>{crew.name}</Link>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className="d-flex flex-row justify-content-end">
                    <a className="btn btn-outline-secondary" href="/crews/create">
                        New crew
                    </a>
                </div>
            </div>
        </div>
    );
};
